<template>
  <div class="text-justify flex">
    <main-container :isPage="true">
      <h1 class="text-center">{{ $t("termsAndConditions.title") }}</h1>
      <hr class="primary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`termsAndConditionsParagraph-${i}`"
      />

      <h2>{{ $t("termsAndConditions.terms.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.terms.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`termsAndConditionsTermsParagraph-${i}`"
      />

      <h2>{{ $t("termsAndConditions.restrictions.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.restrictions.paragraph')"
        :key="`termsAndConditionsRestrictionsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.copyright.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.copyright.paragraph')"
        :key="`termsAndConditionsCopyrightParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.thirdPartyCopyright.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.thirdPartyCopyright.paragraph')"
        :key="`termsAndConditionsThirdPartyCopyrightParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.quality.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.quality.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`termsAndConditionsQualityParagraph-${i}`"
      />

      <h3>{{ $t("termsAndConditions.quality.refundsAndCancellations.title") }}</h3>
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.quality.refundsAndCancellations.paragraph')"
        :key="`termsAndConditionsQualityRefundsAndCancellationsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h3>{{ $t("termsAndConditions.quality.subscriptions.title") }}</h3>
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.quality.subscriptions.paragraph')"
        :key="`termsAndConditionsQualitySubscriptionsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h3>{{ $t("termsAndConditions.quality.shipping.title") }}</h3>
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.quality.shipping.paragraph')"
        :key="`termsAndConditionsQualityShippingParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.goodsAndServices.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.goodsAndServices.paragraphA')"
        :key="`termsAndConditionsGoodsAndServicesParagraphA-${i}`"
      >
        {{ paragraph }}
      </p>
      <ul>
        <li
          v-for="(list, i) in $t('termsAndConditions.goodsAndServices.list')"
          :key="`termsAndConditionsGoodsAndServicesList-${i}`"
        >
          {{ list }}
        </li>
      </ul>
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.goodsAndServices.paragraphB')"
        :key="`termsAndConditionsGoodsAndServicesParagraphB-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.confidentiality.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.confidentiality.paragraph')"
        :key="`termsAndConditionsConfidentialityParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.noConfidentialData.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.noConfidentialData.paragraph')"
        :key="`termsAndConditionsNoConfidentialDataParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.cookies.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.cookies.paragraph')"
        :key="`termsAndConditionsCookiesParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.privacyPolicy.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.privacyPolicy.paragraph')"
        :key="`termsAndConditionsPrivacyPolicyParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.credentials.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.credentials.paragraph')"
        :key="`termsAndConditionsCredentialsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h3>{{ $t("termsAndConditions.credentials.accounts.title") }}</h3>
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.credentials.accounts.paragraph')"
        :key="`termsAndConditionsCredentialsAccountsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.modifications.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.modifications.paragraph')"
        :key="`termsAndConditionsModificationsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.laws.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.laws.paragraph')"
        :key="`termsAndConditionsLawsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("termsAndConditions.contact.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('termsAndConditions.contact.paragraph')"
        :key="`termsAndConditionsContactParagraph-${i}`"
      >
        {{ paragraph }}
      </p>
    </main-container>
  </div>
</template>

<script>
const MainContainer = () =>
  import(/* webpackChunkName: "MainContainerComponent" */ "@/components/Global/MainContainer.vue");

export default {
  name: "TermsAndConditions",
  components: {
    MainContainer
  }
};
</script>
